import { onLoad } from 'utils/on_load'

onLoad(() => {
  // Fixes dropdown login closes on click
  const elements = document.querySelectorAll('#dropdown-login, #dropdown-login li, #dropdown-login input, #dropdown-login label')
  elements.forEach((element) => {
    element.addEventListener("click", (e) => {
      e.stopPropagation()
    })
  })
})
